import script from "./GenericFragment.vue?vue&type=script&lang=ts&setup=true"
export * from "./GenericFragment.vue?vue&type=script&lang=ts&setup=true"

import "./GenericFragment.vue?vue&type=style&index=0&id=e0194264&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0194264"]])

export default __exports__